import React, { PureComponent } from "react";

import { TTP_API_URL } from "Config";
import styles from "./Media.local.scss";
//import classnames from "classnames";
import { getDateLabel } from "Utils";
//import _ from "i18n";

export default class MediaComponent extends PureComponent {
  render() {
    const { language, media, openMediaReveal } = this.props;

    const { preview, fullMediaUrl, webPath, createdAt, docType } = media;

    const titleAttr = `title${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    let path = null;
    if (
      docType === "VIDEO" &&
      preview &&
      (preview.fullMediaUrl || preview.webPath)
    ) {
      path = preview.fullMediaUrl
        ? preview.fullMediaUrl
        : TTP_API_URL + "/" + preview.webPath;
    } else if (docType === "IMAGE") {
      path = fullMediaUrl ? fullMediaUrl : TTP_API_URL + "/" + webPath;
    }

    return (
      <div className={styles.media} onClick={openMediaReveal}>
        {docType === "PPT" || docType === "PDF" ? (
          <div className={styles.docs}>
            <img src={`/img/${docType.toLowerCase()}.png`} alt="" />
            <div className={styles.docInfo}>
              <h3>From: {media[titleAttr]}</h3>
              <span className={styles.date}>{getDateLabel(createdAt)}</span>
            </div>
          </div>
        ) : (
          <div
            className={styles.mediaContent}
            style={{ backgroundImage: `url(${path})` }}
          >
            {docType === "VIDEO" ? (
              <div className={styles.play}>
                <img src="/img/video.png" alt="" />
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/Common/Media/MediaComponent.js